import React, { useEffect } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { SPECIALITY_OPTIONS, SPECIALITY_SERIES } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getSpecialtiesData } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

const Specialties = (props) => {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { specialties } = useSelector(state => state.physicianTargetListAnalysis);
    const { chartSeries, isLoading } = specialties;
   
    useEffect(() => {
        if(company.id){
            dispatch(getSpecialtiesData({ companyId: company.id }));
        }
        
    },[company.id]);
  
    return (
        <Box className="custom-tool-tip custom-hover-bar-color apexchart-horizontal-bar-chart box-sizing-border-box padding-24px">
            <Box className="pb-20px">
                <Typography className="text-lg-semi-bold gray-900">
                    B. Specialties
                </Typography>
            </Box>
            <Box className="min-height-280px">
                {isLoading ? <Skeleton height={'300px'} variant='rectangular' width={'100%'}/> :
                    <BarChart chartOptions={SPECIALITY_OPTIONS} chartSeries={chartSeries} height={300}/>
                }
            </Box>
        </Box>
    );
};

export default Specialties;
